import React from "react";
import {IChatHelperContext} from "../interfaces/IChatHelperContext";
import {IChatManagerContext} from "../interfaces/IChatManagerContext";

export const ChatHelperContext = React.createContext<IChatHelperContext>(undefined as any);

export const ChatManagerContext = React.createContext<IChatManagerContext>(undefined as any);